import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    all2019 () {
      return api.get('/subscriptions')
    },

    all () {
      return api.get('/surveillance/all')
    },

    subscribe (request) {
      return api.post('/surveillance/add', request)
    },

    edit (request) {
      return api.post('/surveillance/update/modules', request)
    },

    updateConventionMembers (request) {
      return api.post('/surveillance/convention/members', request)
    },

    uploadConvention (progress, request) {
      const url = request.year === 2019
        ? '/chart'
        : request.has('role') ? '/surveillance/convention/upamend'
          : '/surveillance/convention/upmain'
      return api.post(
        url,
        request,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progress
        }
      )
    },

    confirmConvention (request) {
      return api.post('/surveillance/convention/confirm', request)
    },

    addMember (request) {
      return api.post('/surveillance/member/add', request)
    },

    updateMember (request) {
      return api.post('/surveillance/member/update', request)
    },

    removeMember (request) {
      return api.post('/surveillance/member/remove', request)
    },

    addMember2019 (request) {
      return api.post('/member/add', request)
    },

    updateMember2019 (request) {
      return api.post('/member/update', request)
    },

    removeMember2019 (request) {
      return api.post('/member/remove', request)
    },

    removeDataset (request) {
      return api.post('/surveillance/dataset/remove', request)
    },

    updateDataset (request) {
      return api.post('/surveillance/dataset/update', request)
    },

    updateDatasetSheets (request) {
      return api.post('/surveillance/dataset/sheets', request)
    },

    updateDatasetDenominators (request) {
      return api.post('/surveillance/dataset/denominators', request)
    },

    getDatasetSheets (request) {
      return api.post('/surveillance/dataset/get/sheets', request)
    },

    getDatasetDenominators (request) {
      return api.post('/surveillance/dataset/get/denom', request)
    },

    getCompleteDataset (request) {
      return api.post('/surveillance/dataset/get/complete', request)
    },

    setEmptyBact (request) {
      return api.post('/surveillance/emptybact', request)
    },

    startExplaur (request) {
      return api.post('/surveillance/explaur/start', request)
    },

    newExplaurSwab (request) {
      return api.post('/surveillance/explaur/newswab', request)
    },

    setExplaurPatient (request) {
      return api.post('/surveillance/explaur/patient', request)
    },

    setExplaurSwabStatus (request) {
      return api.post('/surveillance/explaur/swabst', request)
    },

    updateReaExplaurStatus (request) {
      return api.post('/surveillance/explaur/status', request)
    },

    setSwab (request) {
      return api.post('/surveillance/sink/swab', request)
    },

    updateReaSinkStatus (request) {
      return api.post('/surveillance/sink/status', request)
    },

    close (request) {
      return api.post('/surveillance/close', request)
    }
  }
} else {
  module = {
    _all: [],

    all () {
      return delay(1500)({
        data: {
          v: this._all.slice()
        }
      })
    },

    subscribe (request) {
      this._all.push(request)
      return delay(1500)({
        data: {
          err: 'test'
        }
      })
    },

    uploadConvention (request) {
      return delay(1000)({
        data: {
          err: 'test'
        }
      })
    },

    addMember (request) {
      this._members.push(request)
      return delay(1500)({
        data: {
          err: 'test'
        }
      })
    },

    updateMember (request) {
      this._members.push(request)
      return delay(1500)({
        data: {
          err: 'test'
        }
      })
    }
  }
}
export default module
